import { createSlice } from '@reduxjs/toolkit';
import { logout } from './authSlice';   // listen to logout from any dispatch source

const initialState = {
  toastMessage: '',
  toastVisible: false,
  lightboxPhotos: [],
  lightboxIdx: 0,
  lightboxTitle: '',
  lightboxSubtitle: '',
  lightboxOpen: false,
  settingsOpen: false,
  activeNav: 'home',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showToast(state, action) {
      state.toastMessage = action.payload;
      state.toastVisible = true;
    },
    hideToast(state) {
      state.toastVisible = false;
    },
    openLightbox(state, action) {
      state.lightboxPhotos = action.payload.photos;
      state.lightboxTitle = action.payload.title;
      state.lightboxSubtitle = action.payload.subtitle || '';
      state.lightboxIdx = 0;
      state.lightboxOpen = true;
    },
    closeLightbox(state) {
      state.lightboxOpen = false;
    },
    setLightboxIdx(state, action) {
      state.lightboxIdx = action.payload;
    },
    openSettings(state) {
      state.settingsOpen = true;
      state.activeNav = 'profile';
    },
    closeSettings(state) {
      state.settingsOpen = false;
      state.activeNav = 'home';
    },
    setActiveNav(state, action) {
      state.activeNav = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const {
  showToast,
  hideToast,
  openLightbox,
  closeLightbox,
  setLightboxIdx,
  openSettings,
  closeSettings,
  setActiveNav,
} = uiSlice.actions;

export default uiSlice.reducer;